import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://ie-interactive.emergent.host';
const DEFAULT_OG_IMAGE = 'https://customer-assets.emergentagent.com/job_b2005392-6212-4506-b62b-d5c77af4b77a/artifacts/n8p0qeqa_Logomarca_Horizontal_Preta.png';

const SEO = ({
  title = 'Instituto Eneagrama — A Engenharia do Sistema Humano',
  description = 'Metodologia patenteada de diagnóstico e intervenção comportamental. +3.000 empresas e +70.000 eneagramados em todo o Brasil.',
  path = '/',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  jsonLd = null,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes('Instituto Eneagrama') ? title : `${title} | Instituto Eneagrama`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="icon" type="image/png" href="https://customer-assets.emergentagent.com/job_ie-interactive/artifacts/xbf78gkn_Simbolo_Laranja.png" />
      <link rel="apple-touch-icon" href="https://customer-assets.emergentagent.com/job_ie-interactive/artifacts/xbf78gkn_Simbolo_Laranja.png" />
      <meta name="theme-color" content="#FF6700" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="Instituto Eneagrama" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default SEO;
